import React from 'react';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';

const AutocompletePaper = ({ children, ...props }) => (
  <Paper
    sx={{
      mt: 2,
      borderRadius: 4,
      boxShadow: 'none',
    }}
    {...props}
  >
    {children}
  </Paper>
);

export default AutocompletePaper;

AutocompletePaper.propTypes = {
  children: PropTypes.node.isRequired,
};
